var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.62114,
    y: 1.92193,
    width: 46.1562,
    height: 46.1562,
    rx: 6.07807,
    stroke: "white",
    strokeWidth: 2.15615
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3548 32.5371H29.9619V30.5607H19.3548V32.5371ZM19.3548 26.9371H29.9619V24.9607H19.3548V26.9371ZM16.0937 38.1371C15.5666 38.1371 15.1054 37.9395 14.7101 37.5442C14.3148 37.1489 14.1172 36.6877 14.1172 36.1607V13.7607C14.1172 13.2336 14.3148 12.7724 14.7101 12.3771C15.1054 11.9818 15.5666 11.7842 16.0937 11.7842H27.9854L35.1995 18.9983V36.1607C35.1995 36.6877 35.0019 37.1489 34.6066 37.5442C34.2113 37.9395 33.7501 38.1371 33.2231 38.1371H16.0937ZM26.9972 19.8877V13.7607H16.0937V36.1607H33.2231V19.8877H26.9972Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuDocumentation);
export default __webpack_public_path__ + "static/media/icon_menu_documentation.724c77a54c724ace9375bf50fee78494.svg";
export { ForwardRef as ReactComponent };